export default "Gymnases & complexes sportifs — Collectivités | Solution Éco France";
